const actions = {
  LOAD_COUNTRIES_SETTINGS_REQUEST: 'LOAD_COUNTRIES_SETTINGS_REQUEST',
  LOAD_COUNTRIES_SETTINGS_ERROR: 'LOAD_COUNTRIES_SETTINGS_ERROR',
  LOAD_COUNTRIES_SETTINGS_SUCCESS: 'LOAD_COUNTRIES_SETTINGS_SUCCESS',

  loadCountriesSettingsRequest: () => ({
    type: actions.LOAD_COUNTRIES_SETTINGS_REQUEST,
  }),

  loadCountriesSettingsError: data => ({
    type: actions.LOAD_COUNTRIES_SETTINGS_ERROR,
    payload: data,
  }),

  loadCountriesSettingsSuccess: data => ({
    type: actions.LOAD_COUNTRIES_SETTINGS_SUCCESS,
    payload: data,
  }),
};

export default actions;
